import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    alignItems: 'center',
    flexFlow: 'row nowrap',
    backgroundColor: theme.palette.bracket.champion,
    flex: '0 0 auto',
    padding: theme.spacing(0, 2),
    borderRadius: theme.spacing(1.5),
    height: theme.spacing(6.25),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '&:after': {
      content: '""',
      position: 'absolute',
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.bracket.link}`,
      borderTop: `${theme.spacing(0.125)} solid ${theme.palette.bracket.link}`,
      borderRight: `${theme.spacing(0.125)} solid ${theme.palette.bracket.link}`,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      width: theme.spacing(3),
      height: '100%',
      left: theme.spacing(-5.25),
    },

    '&:before': {
      content: '""',
      position: 'absolute',
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.bracket.link}`,
      width: theme.spacing(2.25),
      height: '100%',
      left: theme.spacing(-2.25),
      top: '-50%',
    },
  },

  trophy: {
    width: theme.spacing(4),
    marginLeft: 'auto',

    '& img': {
      width: '100%',
      height: '100%',
    },
  },

  text: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));
